const images = [
  { src: require("./ar.png"), alt: "ar" },
  { src: require("./att.png"), alt: "tt" },
  { src: require("./bmw.png"), alt: "bm" },
  { src: require("./esa.png"), alt: "sa" },
  { src: require("./ge.png"), alt: "ge" },
  { src: require("./gr.png"), alt: "gr" },
  { src: require("./hp.png"), alt: "hp" },
  { src: require("./hv.png"), alt: "hv" },
  { src: require("./lg.png"), alt: "lg" },
  { src: require("./mc.png"), alt: "mc" },
  { src: require("./mf.png"), alt: "mf" },
  { src: require("./qt.png"), alt: "qt" },
  { src: require("./rt.png"), alt: "rt" },
  { src: require("./st.png"), alt: "st" },
  { src: require("./tg.png"), alt: "tg" },
  { src: require("./vw.png"), alt: "vw" },
  { src: require("./xr.png"), alt: "xr" },
];

export default images;
